import {
  createRootRoute,
  Outlet,
  retainSearchParams,
} from "@tanstack/react-router";
import { z } from "zod";

import { AppProviders } from "#/app/providers";
import { StoreConnectionGate } from "#/features/store-connection";

export const Route = createRootRoute({
  validateSearch: z.object({
    host: z.string().optional(),
    embedded: z.literal(1).optional(),
  }),
  search: { middlewares: [retainSearchParams(["host", "embedded"])] },
  component: RootRoute,
});

function RootRoute() {
  return (
    <AppProviders>
      <StoreConnectionGate>
        <Outlet />
      </StoreConnectionGate>
    </AppProviders>
  );
}
